import debounce from 'debounce';
import { reactive, toRefs } from 'vue';

/**
 * @param {object} Api 
 * @param {function} Api.fetch Função para realizar a busca da listagem
 * @param {function} Api.delete Função para deletar um item
 * @param {object} defaultQuery 
 */
export default function useApiList(Api, defaultQuery = {}) {
    const state = reactive({
        results: [],
        loadingList: false,
        query: {
            page: 1,
            pageSize: 20,
            order: 'desc',
            orderField: 'id',
            ...defaultQuery,
        },
        pagination: {
            total: 0,
            current: 1,
            pages: 1,
        },
    });

    const fetchList = async (query, apiOptions) => {
        try {
            state.loadingList = true;
            const { results, pagination } = await Api.fetch(query || state.query, apiOptions);
            state.results = results;
            state.pagination = pagination;
        } catch (error) {
            console.error(error);
        } finally {
            state.loadingList = false;
        }
    };

    const deleteListItem = async (id, apiOptions) => {
        await Api.delete(id, apiOptions);
        state.results = state.results.filter((result) => result.id !== id);
    };

    const searchList = debounce(async (query, callback, apiOptions) => {
        state.query = { ...state.query, ...query };
        await fetchList(undefined, apiOptions);
        if (callback) {
            callback();
        }
    }, 300, true);

    const changeListPage = debounce(
        async ({ page }, apiOptions) => {
            state.query.page = page;
            await fetchList(undefined, apiOptions);
        },
        300,
        true
    );

    return {
        ...toRefs(state),
        fetchList,
        deleteListItem,
        searchList,
        changeListPage,
    };
}